import { observer } from "mobx-react-lite"
import { store } from "../../../stores/Store"
import { useEffect } from "react"
import { Button, IconButton, LinearProgress } from "@mui/material"
import { Icons } from "../../../misc/Icons"
import PanelHeader from "../../layout/PanelHeader"
import PanelBody from "../../layout/PanelBody"
import { DisplayValue } from "../../.."
import AutomationLogTable from "./AutomationLogTable"


export default observer(function AutomationLogTool() {
    
    const { getLog, log, downloadLog, loadingLog, searchString, setSearchString } = store.AutomationStore

    useEffect(() => {
        if (!log?.length) {
            getLog()
        }
    }, [])

    return (
        <div className="panel panel-dark">
            <PanelHeader>
                <div style={{display: "flex", gap: "10px", flexFlow: "wrap", alignItems: "center"}}>
                    <h2>Automation log</h2>

                    <div className="form-search form-search-dark">
                        <input 
                            autoFocus 
                            value={searchString}
                            placeholder="Search"
                            spellCheck="false"
                            onChange={(e) => setSearchString(e.target.value)} />
                    </div>

                    <Button
                        color="secondary"
                        variant="contained"
                        className="btn btn-sm"
                        disabled={loadingLog}
                        onClick={() => getLog()}>
                        <Icons.Refresh /> Refresh
                    </Button>

                    <Button
                        color="secondary"
                        variant="contained"
                        className="btn btn-sm"
                        disabled={loadingLog || !log?.length}
                        onClick={() => downloadLog()}>
                        <Icons.Download /> Download
                    </Button>
                </div>

                <IconButton color="info" style={{margin: "0 0 auto auto"}} size="small" onClick={() => store.ToolStore.setTool(null)}><Icons.X /></IconButton>
            </PanelHeader>
            
            <PanelBody>
                <AutomationLogTable />
            </PanelBody>
        </div>
    )
})